import React from "react";

const THEMES = [
  "Assumptions and bias",
  "Communication breakdowns",
  "Groupthink",
  "Empathy and listening",
  "Trust and persuasion",
  "Psychological safety",
  "How intelligent people become trapped by flawed narratives",
];

export const BlindFaithThemes = () => (
  <ul className="bf-themes" data-testid="bf-themes">
    {THEMES.map((t) => <li key={t} className="bf-theme">{t}</li>)}
  </ul>
);

const PRACTICES = ["better listening", "critical thinking", "flawed assumptions", "trust", "persuasion"];

export const BlindFaithPractices = () => (
  <ul className="bf-practices" data-testid="bf-practices">
    {PRACTICES.map((p) => <li key={p} className="bf-practice">{p}</li>)}
  </ul>
);

const STAGES = [
  {
    n: "1",
    title: "Meet Jeff",
    copy: ["Jeff joins your team and explains why he no longer believes that sight exists.", "Your job is simple.", "Convince him he is wrong."],
  },
  {
    n: "2",
    title: "The conversation unfolds",
    copy: [
      "There is no fixed lecture and no safe sequence of PowerPoint slides.",
      "Participants interact directly with Jeff.",
      "They question him.",
      "He questions them.",
      "The more information that emerges, the more complicated the conversation becomes.",
      "No two performances unfold in exactly the same way.",
    ],
  },
  {
    n: "3",
    title: "Take it back into the business",
    copy: [
      "The theatrical experience opens up a much wider discussion about how people communicate, make assumptions, trust authority, respond to disagreement and become attached to particular narratives.",
      "Optional post-show activities can then help the team explore those themes in relation to their own organisation.",
    ],
  },
];

export const BlindFaithStages = () => (
  <ol className="bf-stages" data-testid="bf-stages">
    {STAGES.map((s) => (
      <li key={s.n} className="bf-stage" data-testid={`bf-stage-${s.n}`}>
        <span className="bf-stage-num" aria-hidden="true">{s.n}</span>
        <h3 className="bf-stage-title">{s.title}</h3>
        <div className="bf-body bf-body--small">
          {s.copy.map((p) => <p key={p}>{p}</p>)}
        </div>
      </li>
    ))}
  </ol>
);
